<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expenses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Expenses",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expenses",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsExpensesServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "qty",
          sortable: true,
          label: "QTY",
        },
        {
          key: "price",
          sortable: true,
          label: "PRICE",
        },
        {
          key: "subtotal",
          sortable: true,
          label: "SUB TOTAL",
        },

        { key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "supplier",
          sortable: false,
          label: "SUPPLIER",
        },
        
         {
          key: "description",
          sortable: false,
          label: "DESCRIPTION",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // Value from user input for adding category
      data: {
        description: "",
        category: "",
        date: "",
        amount: "",
        paid: "",
        mode: "",
        supplier: "",
        filterdata: {},
      },
      // edit category
      editdata: {
        id: "",
        category: "",
        amount: "",
        paid: "",
        balance: "",
        description: "",
        date: "",
        mode: "",
        supplier: "",
        filterdata: {},
      },
      // make inputs required
      amountError: "",
      paidError: "",
      categoryError: "",
      modeError: "",
      supplierError: "",
      // delete category
      deletedata: {
        amount: "",
        id: "",
        filterdata: {},
      },
      filterdata: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
        supplier: "",
        page: 1,
        per_page: 50,
      },
    };
  },
  
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("expenses", [
      "ExpensesReportPaginated",
      "ExpensesReportPagination",
      "IsExpensesReportServerPaginated",
      "ExpensesReportSummary",
      "SaveStatus",
      "ExpenseCategories",
      "filterStatus",
    ]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("stock", ["Suppliers"]),

    expenseColumns() {
      return this.fields;
    },

    rows() {
      return this.IsExpensesReportServerPaginated
        ? this.ExpensesReportPagination.total
        : this.ExpensesReportPaginated
        ? this.ExpensesReportPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsExpensesReportServerPaginated) {
          return (
            this.ExpensesReportPagination.per_page ||
            this.filterdata.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsExpensesReportServerPaginated) {
          this.filterdata.per_page = value;
          this.handlePageChange(this.filterdata);
        }
      },
    },

    currentPage: {
      get() {
        return this.ExpensesReportPaginated && this.ExpensesReportPagination
          ? this.ExpensesReportPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ExpensesReportPaginated) {
          this.filterdata.page = value;
          this.handlePageChange(this.filterdata);
        }
      },
    },
  },

  updated() {},
  activated() {
    // Refresh data when component is activated (navigated back to)
    this.FetchExpenses(this.filterdata);
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // Refresh data after successful operation
          this.FetchExpenses(this.filterdata);
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpensesReport",
      AddExpenditure: "expenses/recordExpense",
      EditExpenditure: "expenses/editExpenses",
      DeleteExpense: "expenses/deleteExpense",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchModes: "setting/fetchPaymentOptions",
      FetchSuppliers: "stock/fetchSuppliers",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }

      const str = m.toString();
      // Split by decimal point if it exists and take only the integer part
      const integerPart = str.split(".")[0];
      // Remove all non-digits and add commas
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions.filter((mode) => {
        return mode.default == 1;
      });
      this.data.mode = defaultop[0].id;
    },

    addCommas() {
      this.data.amount = this.thousandSeperator(this.data.amount);
      this.data.paid = this.thousandSeperator(this.data.paid);
    },

    editCommas() {
      this.editdata.amount = this.thousandSeperator(this.editdata.amount);
      this.editdata.paid = this.thousandSeperator(this.editdata.paid);
    },

    addExpense(modalId) {
      this.modal_id = modalId;
      if (this.data.amount === "") {
        this.amountError = "Amount Spent is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.paid === "") {
        this.paidError = "Amount Paid is required";
        return;
      } else {
        this.paidError = "";
      }
      if (this.data.category === "") {
        this.categoryError = "Expense Category is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.mode === "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      const paid = this.removeCommas(this.data.paid);
      const amount = this.removeCommas(this.data.amount);
      if (this.data.supplier == "" && amount > paid) {
        this.supplierError = "Supplier field is required";
        return;
      } else {
        this.supplierError = "";
      }

      // Construct payload with clean values (numeric, no commas)
      const payload = {
        description: this.data.description,
        category: this.data.category,
        date: this.data.date,
        amount: Number(amount),
        paid: Number(paid),
        mode: this.data.mode,
        supplier: this.data.supplier || null,
        filterdata: this.filterdata,
      };
      this.AddExpenditure(payload);
    },

    resetAddExp() {
      this.data.date = "";
      this.data.amount = "";
      this.data.paid = "";
      this.data.description = "";
      this.data.category = "";
      this.data.supplier = "";
      this.data.mode = "";
      this.modal_id = "";
    },

    resetEditExp() {
      this.editdata.id = "";
      this.editdata.category = "";
      this.editdata.amount = "";
      this.editdata.paid = "";
      this.editdata.balance = "";
      this.editdata.description = "";
      this.editdata.date = "";
      this.editdata.mode = "";
      this.editdata.supplier = "";
      this.modal_id = "";
    },

    resetDeleteExp() {
      this.deletedata.amount = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.amountError = "";
      this.modeError = "";
      this.categoryError = "";
      this.supplierError = "";
    },
    showEditModal(row) {
      this.editdata.id = row.id;
      this.editdata.category = row.category || "";
      this.editdata.amount = row.amount
        ? this.thousandSeperator(row.amount)
        : "";
      this.editdata.paid = row.paid
        ? this.thousandSeperator(row.paid)
        : row.amount
        ? this.thousandSeperator(row.amount)
        : "";
      this.editdata.balance = row.balance || 0;
      this.editdata.description = row.description || "";
      this.editdata.date = row.date || "";
      this.editdata.mode = row.mode ? row.mode.id : "";
      this.editdata.supplier = row.supplier ? row.supplier.id : "";
    },
    editExpense(modalId) {
      this.modal_id = modalId;

      // Construct payload with clean values (numeric, no commas)
      const payload = {
        id: this.editdata.id,
        category: this.editdata.category,
        amount: Number(this.removeCommas(this.editdata.amount)),
        paid: Number(this.removeCommas(this.editdata.paid)),
        balance: this.editdata.balance,
        description: this.editdata.description,
        date: this.editdata.date,
        mode: this.editdata.mode,
        supplier: this.editdata.supplier || null,
        filterdata: this.filterdata,
      };
      this.EditExpenditure(payload);
    },
    showDeleteModal(row) {
      this.deletedata.amount = row.amount;
      this.deletedata.id = row.id;
    },
    deleteExpenses(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterdata;
      this.DeleteExpense(this.deletedata);
    },
    filterReport() {
      this.FetchExpenses(this.filterdata);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    removeCommas(value) {
      return typeof value === "string"
        ? parseFloat(value.replaceAll(",", ""))
        : parseFloat(value || 0);
    },
    fillPaid() {
      this.data.paid = this.data.amount;
    },

    handlePageChange(newPage) {
      if (this.IsExpensesReportServerPaginated) {
        this.data.page = newPage;
        this.FetchExpenses(this.data);
      }
    },
  },

  created() {
    this.FetchExpenses(this.filterdata);
    this.FetchExpenseCategories();
    this.FetchModes();
    this.FetchSuppliers();
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
  },

  mounted() {
    // Refresh data when component is mounted
    this.FetchExpenses(this.filterdata);
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // Refresh data when navigating to this route
      vm.FetchExpenses(vm.filterdata);
    });
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label>Expense Category</label>
                  <model-list-select
                    :list="ExpenseCategories ? ExpenseCategories : []"
                    v-model="filterdata.category"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Category"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filterdata.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filterdata.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
              <div class="col-3 mt-4">
                <b-button
                  v-if="MyUserPerm && MyUserPerm.add_expenses == 1"
                  class="float-end"
                  variant="primary"
                  v-b-modal.add-expense-modal
                  ><i class="fa fa-plus"></i> Record Expense</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4" align="center">
                <router-link :to="'/expenses/record_bulkexpenses'"
                  ><b-button variant="info"
                    ><i class="fas fa-layer-group"></i> Bulk Expenses</b-button
                  ></router-link
                >
              </div>
              <!-- Search -->
              <div class="col-md-4">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="expenseColumns"
                :rows="ExpensesReportPaginated"
                :total-rows="rows"
                :pagination="ExpensesReportPagination"
                :server-pagination="IsExpensesReportServerPaginated"
                :loading="filterStatus"
                row-class="sales-table-bordered"
              >
                <template #cell(index)="{ index }">
                  {{ index + 1 }}
                </template>
                <template #cell(product)="{ row }">
                  <div
                    class="item-container"
                    v-for="(item, idx) in row.items"
                    :key="idx"
                  >
                    {{ item.product || item.name || (item.category && item.category.name) }}
                  </div>
                </template>

                <template #cell(qty)="{ row }">
                  <div
                    class="item-container"
                    v-for="(item, idx) in row.items"
                    :key="idx"
                  >
                    {{ item.qty || item.quantity || 1 }}
                  </div>
                </template>

                <template #cell(price)="{ row }">
                  <div
                    class="item-container"
                    v-for="(item, idx) in row.items"
                    :key="idx"
                  >
                    {{ thousandSeperator(item.amount || item.SPrice || 0) }}
                  </div>
                </template>

                <template #cell(subtotal)="{ row }">
                  <div
                    class="item-container"
                    v-for="(item, idx) in row.items"
                    :key="idx"
                  >
                    {{
                      thousandSeperator(
                        (item.qty || item.quantity || 1) *
                          parseFloat(item.amount || item.SPrice || 0)
                      )
                    }}
                  </div>
                </template>
                <template #cell(amount)="{ row }">
                  {{ thousandSeperator(row.amount) }}
                </template>
                <template #cell(description)="{ row }">
                  <div
                    class="item-container"
                    v-for="(item, idx) in row.items"
                    :key="idx"
                  >
                    {{ item.description }}
                  </div>
                </template>

                <template #cell(supplier)="{ row }">
                  {{ row.supplier  }}
                </template>

                <template #cell(paid)="{ row }">
                  {{ thousandSeperator(row.paid) }}
                </template>

                <template #cell(balance)="{ row }">
                  {{ thousandSeperator(row.balance) }}
                </template>

                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>
                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="MyUserPerm.edit_expenses == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-expense-modal
                      @click="showEditModal(row)"
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      v-if="MyUserPerm.delete_expenses == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-expense-modal
                      @click="showDeleteModal(row)"
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add expense modal starts -->
            <b-modal id="add-expense-modal" hide-footer @hidden="resetAddExp">
              <template #modal-title> Record New Expense</template>
              <div class="form-group mb-2">
                <label
                  >Expense Category <span class="text-danger">*</span></label
                >
                <model-list-select
                  :list="ExpenseCategories ? ExpenseCategories : []"
                  v-model="data.category"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Expense Category"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="categoryError">
                  <em>{{ categoryError }}</em>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Expense Amount <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.amount"
                    @input="resetErrors(), addCommas(), fillPaid()"
                    placeholder="Amount expense amount"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Amount Paid</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.paid"
                    @input="resetErrors(), addCommas()"
                    placeholder="Amount Paid"
                  />
                </div>
                <div class="text-danger" v-if="paidError">
                  <em>{{ paidError }}</em>
                </div>
              </div>
              <div
                class="form-group mb-2"
                v-if="MyUserPerm.backdate_entries == 1"
              >
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="data.date"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Payment Method</label>
                <div class="input-group">
                  <model-list-select
                    :list="PaymentOptions ? PaymentOptions : []"
                    v-model="data.mode"
                    option-value="id"
                    option-text="mode"
                    placeholder="Select Method"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <label>Supplier </label>
                  <model-list-select
                    :list="Suppliers ? Suppliers : []"
                    v-model="data.supplier"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Supplier"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="supplierError">
                  <em>{{ supplierError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                  <textarea
                    rows="5"
                    class="form-control"
                    v-model="data.description"
                    placeholder="Description"
                  >
                  </textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  type="button"
                  class="btn btn-primary"
                  disabled
                >
                  <i class="fa fa-check"></i> Save Expense
                  <b-spinner variant="light" small label="Saving"></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary"
                  @click="addExpense('add-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Expense
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- edit modal starts -->
            <b-modal id="edit-expense-modal" hide-footer @hidden="resetEditExp">
              <template #modal-title>
                Edit Expense - {{ editdata.category }}</template
              >
              <div class="form-group mb-2">
                <label>Expense Category</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="editdata.category"
                  placeholder="Category"
                  readonly
                />
              </div>
              <div class="form-group mb-2">
                <label>Expense Amount</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="editdata.amount"
                  @input="editCommas()"
                  placeholder="Amount"
                />
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Amount Paid</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="editdata.paid"
                  @input="editCommas()"
                  placeholder="Amount Paid"
                />
                <div class="text-danger" v-if="paidError">
                  <em>{{ paidError }}</em>
                </div>
              </div>
              <div
                class="form-group mb-2"
                v-if="MyUserPerm.backdate_entries == 1"
              >
                <label>Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="editdata.date"
                  v-limit-future-date
                />
              </div>
              <div class="form-group mb-2">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="editdata.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="modeError">
                  <em>{{ modeError }}</em>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Supplier</label>
                <model-list-select
                  :list="Suppliers ? Suppliers : []"
                  v-model="editdata.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="supplierError">
                  <em>{{ supplierError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <textarea
                  rows="3"
                  class="form-control"
                  v-model="editdata.description"
                  placeholder="Description"
                >
                </textarea>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  type="button"
                  class="btn btn-primary"
                  disabled
                >
                  <i class="fa fa-check"></i> Saving...
                  <b-spinner variant="light" small label="Saving"></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary"
                  @click="editExpense('edit-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-expense-modal"
              hide-footer
              @hidden="resetDeleteExp"
            >
              <template #modal-title>
                Delete Expenditure of
                {{ thousandSeperator(deletedata.amount) }}</template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this expense? This is a permanent
                    action.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  type="button"
                  class="btn btn-danger"
                  disabled
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner variant="light" small label="Deleting"></b-spinner>
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-danger"
                  @click="deleteExpenses('delete-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.sales-table-bordered td {
  border-bottom: 1px solid #000 !important;
}
</style>
